import invariant from 'invariant';

import { configString } from 'config/appConfigUtils';
import { isNotEmpty } from 'utils/functional';

export function getVolopsSearchIndex(
  actionDateFacet?: Record<string, number> | null | undefined,
  sort?: string | null | undefined,
) {
  const volopsIndexName = configString('algolia', 'volopsIndexName');
  invariant(isNotEmpty(volopsIndexName), 'volopsIndexName cannot be empty');

  if (actionDateFacet && (actionDateFacet.endsGT || actionDateFacet.startsLT)) {
    return `${volopsIndexName}-starts-asc`;
  }

  if (sort === 'relevance') return volopsIndexName;

  return `${volopsIndexName}-published-desc`;
}
